export default [
    {
        message:
            "A critical security patch update is available. Please install it promptly to safeguard our systems and data. Before applying the patch, back up essential data. Coordinate a suitable update time to minimize disruptions, and restart systems after installation. Verify the patch's successful application. Report any issues to IT support. Inform your colleagues. If you need assistance, contact IT support. Your cooperation is vital in prioritizing security.",
        timestamp: Date.now(),
    },
];
